/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Login_Sent_BodyInputs */



/**
* | output |
* | --- |
* | "We've sent a sign-in link to {email}. Tap the link to sign in." |
*
* @param {Login_Sent_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const login_sent_body = /** @type {((inputs: Login_Sent_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Sent_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`We hebben een aanmeldlink gestuurd naar ${i?.email}. Tik op de link om aan te melden.`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Nous avons envoyé un lien de connexion à ${i?.email}. Cliquez sur le lien pour vous connecter.`)
	return /** @type {LocalizedString} */ (`We've sent a sign-in link to ${i?.email}. Tap the link to sign in.`)
});